const config = {
  baseUrl: "/",
  // baseUrl: "http://localhost:9092",
};

export default config;
